export default __webpack_public_path__ + "static/media/android-ios-system.260d9773.svg";